import formReducer from '../formsReducer'

const formName = 'orders/filter'

export default formReducer(formName)
